import { render, staticRenderFns } from "./ComponentRescueteamsDetail.vue?vue&type=template&id=98b705b8&"
import script from "./ComponentRescueteamsDetail.vue?vue&type=script&lang=js&"
export * from "./ComponentRescueteamsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports